module.exports = __webpack_public_path__ + "static/img/pc_pd_v2_1.cb71fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_v2_1.png
// module id = RVFN
// module chunks = 0